import { render, staticRenderFns } from "./core.vue?vue&type=template&id=59972ed6&scoped=true"
import script from "./core.vue?vue&type=script&lang=js"
export * from "./core.vue?vue&type=script&lang=js"
import style0 from "./core.vue?vue&type=style&index=0&id=59972ed6&prod&lang=css"
import style1 from "./core.vue?vue&type=style&index=1&id=59972ed6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59972ed6",
  null
  
)

export default component.exports